import Box from '@mui/material/Box'
import GradeIcon from '@mui/icons-material/Grade'
import ReactCountryFlag from 'react-country-flag'

const AttractionMetaData = ({ title, subtitle, countryCode }) => {
  console.log('>>>>>>>>> Item Type  title: ', title + 'subtitle' + subtitle)
  if (countryCode) {
    var country = `https://flagcdn.com/16x12/${countryCode.toLowerCase()}.png`
    var country_2x = `https://flagcdn.com/16x12/${countryCode.toLowerCase()}.png 3x`
    var country_3x = `https://flagcdn.com/16x12/${countryCode.toLowerCase()}.png 3x`
  }
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          color: '#28AB83',
          alignItems: 'center',
          px: 3,
          paddingTop: '24px',
        }}
      ></Box>
      <div
        style={{
          marginTop: '-10px',
          marginBottom: '20px',
          textAlign: 'left',
          listStyle: 'none',
          color: 'var(--gray100)',
          padding: '0 20px 0 20px',
        }}
      >
        <p className="title1"> {title}</p>
      </div>

      <div
        style={{
          marginTop: '-10px',
          marginBottom: '20px',
          textAlign: 'left',
          listStyle: 'none',
          color: '#181818',
          padding: '0 20px 0 20px',
        }}
      >
        <p className="body3">
          {' '}
          {subtitle}
          {countryCode && (
            <span>
              {/* <ReactCountryFlag countryCode={countryCode} svg /> */}
              <img
                src={country}
                srcSet={country_2x + ', ' + country_3x}
                width="16"
                height="12"
              ></img>
            </span>
          )}
        </p>
      </div>
    </>
  )
}

export default AttractionMetaData
